import * as L from 'leaflet';
import type { GeoJsonObject } from 'geojson';
import { MapObjectReference } from './map-object';
import { MapObjectPopover } from './map-object-popover';

export const MAP_FOCUS_COLOR = '#374151';
export const MAP_FOCUS_DASH_ARRAY = '4 3';

/** Resolved geometry and presentation; no dependency on a visible business layer. */
export interface MapFocusObject {
  readonly reference: MapObjectReference;
  readonly geometry: GeoJsonObject;
  popup: MapObjectPopover;
  readonly anchor?: L.LatLngExpression;
  readonly pointIcon?: L.Icon | L.DivIcon;
  readonly popupOffset?: L.PointExpression;
}

/** Focus is above ordinary markers (600), Selection above Focus, Popups above both. */
export function ensureMapObjectPane(map: L.Map, name: string, zIndex: number): HTMLElement {
  const pane = map.getPane(name) ?? map.createPane(name);
  pane.style.zIndex = String(zIndex);
  pane.style.pointerEvents = 'none';
  return pane;
}
